// extracted by mini-css-extract-plugin
export default {"container":"Navigation_container__iDnzr","containerMobile":"Navigation_containerMobile__fiu+b","link":"Navigation_link__xVB44"};